import { call, takeLatest } from "redux-saga/effects";
import * as userApis from "../apis/userApis"
import { INVITE_USER, LOGIN_TIME_LINE_REPORT, PORTAL_DROPDOWN, REMOVE_PORTAL, USER_DELETE, USER_EDIT, USER_LIST, USER_VIEW } from "../actions/types";

export function* userListWorker(action) {
    try {
        const res = yield call(userApis.usersListApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* userInviteWorker(action) {
    try {
        const res = yield call(userApis.userInviteApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* portalDropDownWorker(action) {
    try {
        const res = yield call(userApis.portalDropDownApi, {});
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}


export function* userViewWorker(action) {
    try {
        const res = yield call(userApis.userViewApi, {
            id: action.id,
        });
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* userEditWorker(action) {
    try {
        const res = yield call(userApis.userEditApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* userDeleteWorker(action) {
    try {
        const res = yield call(userApis.userDeleteApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* getLoginReportWorker(action) {
    try {
        const res = yield call(userApis.getLoginReportApi, {
            id: action.id,
        });
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* removePortalWorker(action) {
    try {
        const res = yield call(userApis.removePortalApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}




export function* userListWatcher() {
    yield takeLatest(USER_LIST, userListWorker);
}

export function* userInviteWatcher() {
    yield takeLatest(INVITE_USER, userInviteWorker);
}

export function* portalDropDownWatcher() {
    yield takeLatest(PORTAL_DROPDOWN, portalDropDownWorker);
}

export function* userViewWatcher() {
    yield takeLatest(USER_VIEW, userViewWorker);
}

export function* userEditWatcher() {
    yield takeLatest(USER_EDIT, userEditWorker);
}

export function* userDeleteWatcher() {
    yield takeLatest(USER_DELETE, userDeleteWorker);
}

export function* getLoginReportWatcher() {
    yield takeLatest(LOGIN_TIME_LINE_REPORT, getLoginReportWorker);
}

export function* removePortalWatcher() {
    yield takeLatest(REMOVE_PORTAL, removePortalWorker);
}
